module.exports = __webpack_public_path__ + "media/assets/cardBookNowGolden-0dc5434cb5389d437c8c6ed9af47bad4.png";